<template>
  <div
    :class="severityColorClass"
    class="tw:lg:min-h-[62px] tw:w-full tw:text-sm tw:md:flex tw:relative tw:md:gap-4 tw:px-4 tw:py-4 tw:mb-[2px]"
  >
    <div
      class="tw:flex-col tw:md:flex-row tw:flex tw:w-full tw:md:max-w-screen-lg tw:lg:max-w-screen-xl tw:mx-auto tw:md:px-4 tw:md:justify-between tw:md:items-center"
    >
      <div :class="dismissible ? 'tw:w-4/5 tw:md:w-[90%]' : 'tw:w-full'" class="tw:mr-10">
        <div v-if="header" class="tw:flex tw:items-center tw:text-sm">
          <strong>{{ header }}</strong>
        </div>
        <p v-html="description" />
      </div>

      <slot name="ctaContent" class="tw:md:ml-4 tw:mt-4 tw:md:mt-0" :class="dismissible ? 'tw:mr-8' : ''" />

      <button
        v-if="dismissible"
        class="tw:ml-4 tw:self-start tw:outline-none tw:cursor-pointer"
        @click="handleDismiss"
        @keydown.enter="handleDismiss"
        aria-label="Dismiss notification"
        type="button"
      >
        <Close class="tw:size-2.5" />
        <span class="tw:sr-only">Dismiss</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed, inject } from 'vue'

import Close from '@/components/icons/Close.svg?component'

const dismissNotification = inject('dismissNotification')
const props = defineProps({
  description: {
    type: String,
    required: true,
    default: '',
  },
  header: {
    type: String,
    required: false,
    default: '',
  },
  severity: {
    type: String,
    required: false,
    default: 'INFO',
    validator(value) {
      return ['CRITICAL', 'WARNING', 'INFO'].includes(value)
    },
  },
  dismissible: {
    type: Boolean,
    required: false,
    default: false,
  },
  id: {
    type: String,
    required: true,
    default: '',
  },
  ttl: {
    type: Number,
    required: false,
  },
})

const severityColorClass = computed(() => {
  if (props.severity === 'CRITICAL') return 'tw:bg-red-200'
  if (props.severity === 'WARNING') return 'tw:bg-orange-200'
  return 'tw:bg-blue-200'
})

const handleDismiss = () => {
  dismissNotification(props.id, props.ttl)
}
</script>
